// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthWrapper_wrapper__hympI","videoTag":"AuthWrapper_videoTag__dGGjl","employeeLoginButton":"AuthWrapper_employeeLoginButton__GfMAM"};